export default __webpack_public_path__ + "4b3a487b932f50bf511e75a953b92219.svg";